<template>
    <div>
        <div class="mb-4 w-11/12 lg:w-full mx-auto">
            <h2 class="text-brand-gray-600 text-2xl">Enter a location</h2>
            <div class="grid sm:grid-cols-2 sm:gap-6 space-y-4 sm:space-y-0">
              <div class="py-2 px-2 rounded-2xl bg-white shadow-inner-md">
                <label for="location" class="sr-only">Your Location</label>
                <input type="text"
                       class="w-full border-0 appearance-none rounded-2xl"
                       name="postalCode"
                       id="location"
                       v-model="searchLocation"
                       placeholder="Postal Code, City, and/or State"/>
                <label for="distance" class="sr-only">Distance </label>
              </div>
              <div class="py-2 px-2 rounded-2xl bg-white shadow-inner-md">
                <select v-model="distance" id="distance" @change="findReviews" class="w-full border-0 appearance-none rounded-2xl">
                  <option value="25">Within 25 miles</option>
                  <option value="50">Within 50 miles</option>
                  <option value="75">Within 75 miles</option>
                  <option value="100">Within 100 miles</option>
                  <option value="150">Within 150 miles</option>
                  <option value="200">Within 200 miles</option>
                  <option value="250">Within 250 miles</option>
                  <option value="500">Within 500 miles</option>
                </select>
              </div>
            </div>
        </div>
        <div  v-show="searching">
            <h2>
                <i class="fal fa-spinner fa-spin"></i> Searching for Events
            </h2>
        </div>
        <div class="w-11/12 lg:w-full mx-auto" v-if="searchResults !== null && searchResults.length > 0">
            <div class="flex justify-between mb-4">
                <a href="#" @click.prevent="showModal=true" class="text-brand-teal font-medium"><i class="fal fa-bell"></i> Sign Up for alerts</a>
                <div class="text-brand-teal font-medium">
                    <a href="#" @click.prevent="sortByDate()" v-if="sortBy === 'distance' ">Sort By Date <i class="fal fa-sort"></i></a>
                    <a href="#" @click.prevent="sortByDistance()" v-if="sortBy === 'date' ">Sort By Distance <i class="fal fa-sort"></i></a>
                </div>
            </div>
            <div class="space-y-4">
              <div class="flex flex-col lg:grid lg:grid-cols-5 lg:gap-4 items-center bg-white px:8 lg:px-16 border-2 rounded-2xl border-brand-gray-400 py-8"
                   v-for="(review,idx) in searchResults">
                <a :href="`/event/${review.lectureId}`"
                   class="text-brand-teal text-left lg:text-right px-8 my-4 lg:my-auto underline">{{review.city}}, {{review.state}}</a>

                <div class="px-8 my-4 lg:my-auto">
                  <i class="fal fa-calendar-alt"></i> {{review.startDate | date('MMM DD, YYYY')}}
                </div>
                <div class=" px-8 my-4 lg:my-auto">
                  <i class="fal fa-alarm-clock"></i> {{review.time}}
                </div>
                <div class="relative px-8 text-sm flex bg-transparent my-4 lg:my-0">
                  <a href="#" title="Click to view full location information"
                     @click.prevent="locationFocus = locationFocus===idx ? null : idx"
                     class="block transition-all ease-in-out duration-75"
                     :class="{
                        'absolute z-10 left-0 top-0 -translate-y-1/2 cursor-pointer bg-white h-auto p-4 overflow-visible border rounded-lg border-brand-gray-600': locationFocus===idx,
                        'overflow-hidden bg-white lg:h-6 py-0': locationFocus !== idx
                       }"
                  >
                    <span class="whitespace-pre-wrap" :class="{'underline': locationFocus !== idx}">{{review.locationDetails}}</span>
                  </a>
                </div>
                <div class="px-8 flex justify-start lg:justify-center my-4 lg:my-auto">
                  <a :href="`/Cart/add?sku=${buyNowSku}&eventId=${review.lectureId}`" title="Sign Up Now!"
                     class="btn btn-orange"
                  >
                    ${{reviewCost(review.lectureType)}}
                  </a>
                </div>
              </div>
            </div>
        </div>
        <div v-else-if="searchResults !== null && searchResults.length === 0">
            <a class="text-pink-bright" href="#" @click.prevent="showModal=true" ><i class="fal fa-bell"></i> Sign Up for alerts</a>
            <div class="mt-6">
                <p>We do not currently have any reviews scheduled in your area within the distance you specified.<br/>
                    Try increasing the distance of your search.</p>
                <p class="my-6"><strong>OR</strong></p>
                <p>Why not checkout <a href="/nclex-rn" class="text-blue-bright">Hurst Now</a> or <a href="/nclex-rn" class="text-blue-bright">Hurst N-Stream</a>?</p>
            </div>
        </div>

        <modal v-show="showModal" :show="showModal" @close-modal="showModal=false">
            <h2 slot="modal-header" class="text-brand-gray-600 text-xl">Sign Up For Upcoming Event Alerts</h2>
            <div>
                <p class="mb-8">Give us your email address and the dates that you would like to take a review,
                    and we'll send you an alert whenever a new event is added in your area.</p>
                <form class="max-w-md mx-auto mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                    <div class="sm:col-span-6">
                        <label for="input" class="block text-sm font-medium leading-5 text-brand-gray-700">Email Address</label>
                        <div class="mt-1 rounded-md shadow-sm">
                        <input type="email"
                               id="input"
                               class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                               placeholder="jane.doe.RN@example.com" v-model="alert_email_address">
                        </div>
                    </div>
                    <p class="sm:col-span-6">When do you want to take a review?</p>
                    <div class="sm:col-span-3">
                        <label for="date_range_start" class="block text-sm font-medium leading-5 text-brand-gray-700">Start Date</label>
                        <div class="mt-1 rounded-md shadow-sm">
                            <v-date-picker
                                :input-props='{
                                    id: "date_range_start",
                                        class: "form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                                    }'
                                    is-dark
                                    color="indigo"
                                    v-model="alert_date_range_start"></v-date-picker>
                        </div>
                    </div>
                    <div class="sm:col-span-3">
                        <label for="date_range_end" class="block text-sm font-medium leading-5 text-brand-gray-700">End Date</label>
                        <div class="mt-1 rounded-md shadow-sm">
                            <v-date-picker
                                    :input-props='{
                                    id: "date_range_end",
                                        class: "form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                                    }'
                                    is-dark
                                    color="indigo"
                                    v-model="alert_date_range_end"></v-date-picker>
                        </div>
                    </div>
                    <div class="sm:col-span-6 flex justify-between">
                        <button :disabled="!canSubmit" @click.prevent="alertSignup()" class="btn btn-green">
                            Sign Me Up!
                        </button>
                        <button @click.prevent="showModal=false" class="btn btn-orange">Cancel</button>
                    </div>
                </form>
                <div slot="modal-footer">
                    <p >By completing this form, you are agreeing to have Hurst Review email you
                        marketing materials related to upcoming events. You may unsubscribe at any time by clicking the link
                        contained in the emails we send you.</p>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import 'url-search-params-polyfill';
import axios from 'axios';
import swal from 'sweetalert2';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/dark.css';
import moment from 'moment';

export default {
        name: "ReviewSchedule",

        components: {
            flatPickr
        },

        props: {
            reviewType: String,
            provinces: Array,
            scheduleType: String,
            showLocationDetails: {
                type: Boolean,
                default: false
            },
            signupNow: {
                type: Boolean,
                default: false
            },
            buyNowSku: {
                type: String,
                default: ''
            },
            upgrade: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                alert_date_range_end: '',
                alert_date_range_start: '',
                alert_email_address: '',
                autocomplete: null,
                canGeoLocate: false,
                distance: 100,
                findingLocation: false,
                findingNearbyReviews: false,
                geoLocating: false,
                locationFocus: null,
                latitude: null,
                location: null,
                longitude: null,
                picker_config: { dateFormat: 'Y-m-d', altFormat: 'F j, Y', altInput: true, wrap: true },
                searching: false,
                searchLocation: null,
                searchResults: null,
                showModal: false,
                showReviews: false,
                sortBy: "date",
                state: ""
            };
        },

        computed: {
            canSubmit() {
                return this.alert_email_address !== '' && this.alert_date_range_start !== '' && this.alert_date_range_end !== '';
            },
        },

        mounted() {
            let mapsScript = document.createElement('script');
            mapsScript.setAttribute('src', "https://maps.googleapis.com/maps/api/js?key=AIzaSyDVx_WowNgwEq6yOXVVjp7Xt71iqUwcT_8&libraries=places&callback=initAutocomplete");
            mapsScript.async = true;
            document.head.appendChild(mapsScript);

            let urlParams = new URLSearchParams(window.location.search);

            window.initAutocomplete = () => {
                this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('location'), {types: ['geocode']});
                this.autocomplete.addListener('place_changed', this.addressSelected);
            };

            if (urlParams.has('state')) {
                this.state = urlParams.get('state');
                this.distance = 500;
                this.geolocateState();
            } else if (localStorage.getItem('lastSearch') !== null) {
                let lastSearch = JSON.parse(localStorage.getItem('lastSearch'));
                this.latitude = lastSearch.lat;
                this.longitude = lastSearch.lng;
                this.searchLocation = lastSearch.searchAddress;
                this.distance = lastSearch.distance;

                this.findReviews();
            }

            if (localStorage.getItem('sortBy') !== null) {
                this.sortBy = localStorage.getItem('sortBy');
            }
        },

        methods: {
            reviewCost(reviewType) {
                if (this.upgrade) {
                    switch(this.buyNowSku) {
                        case 'now-live-pn-upgrade':
                            return 75;
                        case 'now-live-upgrade':
                            return 150;
                        case 'now-live-plus-upgrade':
                            return 100;
                    }
                }else {
                    return reviewType === 'live' ? 399 : 275;
                }
            },

            async alertSignup() {
                try {
                    this.showModal = false;
                    swal({
                        type: 'info',
                        html: "<h2><i class='fal fa-spinner fa-spin'></i> Saving your subscription</h2>",
                        showConfirmButton: false
                    });
                    await axios.post('/event-alerts', {
                        'email': this.alert_email_address,
                        'date_start': moment(this.alert_date_range_start).format('YYYY-MM-DD'),
                        'date_end': moment(this.alert_date_range_end).format('YYYY-MM-DD'),
                        'lat': this.latitude,
                        'lng': this.longitude,
                        'location': this.searchLocation,
                        'review_type' : this.reviewType,
                        'distance': parseInt(this.distance, 10)
                    });

                    this.showModal = false;


                    this.alert_email_address = '';
                    this.alert_date_range_start = '';
                    this.alert_date_range_end = '';
                    swal({
                        type: 'success',
                        text: "Your request has been processed. We'll send you an email to confirm your subscription. Once you confirm it, you'll be alerted whenever new events are added.",
                        showCancelButton: false
                    });
                }catch (e) {
                    this.showModal = false;

                    this.alert_email_address = '';
                    this.alert_date_range_start = '';
                    this.alert_date_range_end = '';

                    swal({
                        type: 'error',
                        html: 'We were unable to complete your request. Please wait a minute and try again. If this continues to happen, please <a href="/contact">let us know</a>.',
                        showCancelButton: false
                    })
                }
            },

            sortByDistance() {
                this.sortBy = 'distance';
                localStorage.setItem('sortBy', this.sortBy);

                this.searchResults.sort(function(first, second) {
                    return first.distance - second.distance;
                });
            },

            sortByDate() {
                this.sortBy = 'date';
                localStorage.setItem('sortBy', this.sortBy);

                this.searchResults.sort(function(first, second) {
                    return new Date(first.startDate) - new Date(second.startDate);
                });
            },

            showDetails(review) {
                if(this.signupNow) {
                    window.location = `/Cart/add?sku=${this.buyNowSku}&eventId=${review.lectureId}`;
                }else {
                    this.displayEvent = review;
                    window.location = `/event/${review.lectureId}`;
                }
            },

            hideDetails() {
                this.displayEvent = null;
                this.showModal = false;
            },

            async geolocate() {
                let {data: {results}} = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.latitude},${this.longitude}&result_type=postal_code&key=AIzaSyDVx_WowNgwEq6yOXVVjp7Xt71iqUwcT_8`);
                console.log(results);
                this.location = results[0];
                this.searchLocation = this.location.formatted_address;
                this.findingLocation = false;
            },

            async geolocateState() {
                let {data: {results}} = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${this.state}&result_type=postal_code&key=AIzaSyDVx_WowNgwEq6yOXVVjp7Xt71iqUwcT_8`);
                this.location = results[0];
                this.searchLocation = this.location.formatted_address;
                this.latitude = this.location.geometry.location.lat;
                this.longitude = this.location.geometry.location.lng;
                this.findReviews();
            },

            myPosition() {
                if (navigator.geolocation) {
                    this.canGeoLocate = true;
                    this.findingLocation = true;
                    navigator.geolocation.getCurrentPosition(async (position) => {
                        this.latitude = position.coords.latitude;
                        this.longitude = position.coords.longitude;
                        await this.geolocate();
                        this.findingNearbyReviews = true;
                        await this.findReviews();
                        this.findingNearbyReviews = false;
                    });
                }
            },

            async addressSelected() {
                let place = this.autocomplete.getPlace();
                console.log(place);
                this.latitude = place.geometry.location.lat();
                this.longitude = place.geometry.location.lng();
                this.searchLocation = place.formatted_address;
                this.findingNearbyReviews = true;
                await this.findReviews();
                this.findingNearbyReviews = false;
            },

            async findReviews() {
                this.searchResults = null;
                this.searching = true;
                if (this.latitude !== null && this.longitude !== null ) {
                    let response = await axios.get(`/ajax/reviews-near-me?lat=${this.latitude}&lng=${this.longitude}&distance=${this.distance}&type=${this.reviewType}`);
                    this.searchResults = response.data;
                    localStorage.setItem('lastSearch', JSON.stringify({
                        lat: this.latitude,
                        lng: this.longitude,
                        searchAddress: this.searchLocation,
                        distance: this.distance
                    }));

                    if (this.sortBy === 'distance') {
                        this.sortByDistance();
                    }
                }
                this.searching = false;
            }
        }
    }
</script>

<style scoped lang="scss">

</style>